export default __webpack_public_path__ + "static/media/background_download.86443805.png";